import { useAuth } from '@ankr.com/auth';

import { AUTH_APP_ID, AUTH_APP_PATH, AUTH_PATH } from '../const';

export interface UseSSOAuthProps {
  hasAPIKeysNotification?: boolean;
  referralCode?: string;
}

export const useSSOAuth = ({
  hasAPIKeysNotification,
  referralCode,
}: UseSSOAuthProps = {}) =>
  useAuth({
    appId: AUTH_APP_ID,
    appPath: AUTH_APP_PATH,
    authPath: AUTH_PATH,
    hasAPIKeysNotification,
    hasClickwrapAgreement: true,
    hasReferralCodeBox: true,
    referralCode,
  });
